import React from 'react'
import styled from 'styled-components'
import { breakpoints } from '../../../constants/breakpoints.constants'

import { content } from '../../../../config'

const { BANNER_APP_DESKTOP, BANNER_APP_MOBILE } = content

const MOBILE_BANNER_APP = `../../../../assets/images/banners-app/${BANNER_APP_MOBILE}`
const DESKTOP_BANNER_APP = `../../../../assets/images/banners-app/${BANNER_APP_DESKTOP}`

export const AppStoreBanner = styled.div`
	background-image: url(${DESKTOP_BANNER_APP});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 40vw;
	width: 100%;

	@media screen and (max-width: ${breakpoints.LAPTOP_M}px) {
		height: 50vw;
	}

	@media screen and (max-width: ${breakpoints.LAPTOP}px) {
		height: 50vw;
	}

	@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
		background-size: cover;
		background-image: url(${MOBILE_BANNER_APP});
		height: 85vw;
	}
`

export const ContainerAppStoreBtn = styled.div`
	display: flex;
	position: absolute;
	flex-direction: row;
	bottom: 0vh;
	right: 48vw;

	@media screen and (min-width: ${breakpoints.MOBILE_L}px) {
		bottom: 3vh;
	}

	@media screen and (min-width: ${breakpoints.MEDIUM_SCREEN}px) {
		bottom: 5vh;
		right: 48vw;
	}

	@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
		flex-direction: column;
	}

	@media screen and (min-width: ${breakpoints.LAPTOP}px) {
		bottom: 19vh;
		right: 48vw;
	}

	@media screen and (min-width: ${breakpoints.LAPTOP_M}px) {
		bottom: 17vh;
		right: 47.8vw;
	}

	@media screen and (min-width: ${breakpoints.LAPTOP_L}px) {
		bottom: 18vh;
		right: 48vw;
	}

	a {
		img {
			object-fit: contain;
			width: 10vw;

			@media screen and (max-width: ${breakpoints.LAPTOP_L}px) {
				width: 21vh;
			}

			@media screen and (max-width: ${breakpoints.LAPTOP_M}px) {
				width: 30vh;
			}

			@media screen and (max-width: ${breakpoints.LAPTOP}px) {
				width: 20vh;
			}

			@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
				width: 30vw;
			}

			@media screen and (max-width: ${breakpoints.MOBILE_L}px) {
				width: 40vw;
			}
		}
	}
`
